module.exports = {
    userInfo:{
        name:'姓名',
        number:'联系方式',
        EMail:'电子邮箱',
        massage:'留言内容',
        followUs:'联系我们'
    }
}